
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { HelpService } from '@/services'
import Editor from '@/components/editor/index.vue'
@Component({
    components: {
        Editor
    }
})
export default class extends Vue {
    private loading = false
    private isLoading = true
    private typeList: any[] = []
    private form = {
        title: '',
        typeId: '',
        recommend: 0,
        content: ''
    }
    private rules = {
        title: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
        typeId: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        content: [{ required: true, validator: this.contentValidator }]
    }
    get formRef() {
        return this.$refs.createTypeRef as ElForm
    }

    mounted() {
        Reflect.set(this.form, 'typeId', +this.$route.query.id)
        this.getList()
    }

    private async getList() {
        this.isLoading = true
        const result = await HelpService.getArticleTypes({})
        if (result.status === 200) {
            this.typeList = result.data
        }
        this.isLoading = false
    }

    contentValidator(rule: any, value: any, callback: Function) {
        if (!this.form.content) {
            callback(new Error('请输入内容'))
        }
        callback()
    }
    onConfirm() {
        this.formRef.validate(async valid => {
            if (valid) {
                this.loading = true
                const params = {
                    type_id: this.form.typeId,
                    title: this.form.title,
                    content: this.form.content,
                    recommend: +this.form.recommend
                }
                const result = await HelpService.createArticle(params)
                if (result.status === 200) {
                    this.$msuccess('创建成功!')
                }
                this.loading = false
            }
        })
    }

    onContentChange(value: string) {
        this.form.content = value
    }

    onReset() {
        this.formRef.resetFields()
    }
}
